import { render, staticRenderFns } from "./DeleteFriendCell.vue?vue&type=template&id=52bb7a61&"
import script from "./DeleteFriendCell.vue?vue&type=script&lang=babel&"
export * from "./DeleteFriendCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports